export default function LoadingRows({ label = 'Loading…' }) {
  return (
    <div className="data-loading-rows" role="status" aria-live="polite" aria-busy="true">
      <p>{label}</p>
      <div aria-hidden="true">
        {Array.from({ length: 6 }, (_, index) => (
          <div className="data-loading-row" key={index}><i /><span /><b /></div>
        ))}
      </div>
    </div>
  );
}
